// src/lib/utils/permission/permissionLabels.js
import { PERM } from "./permissions";

// ✅ UI 표시용 라벨(권한 키 -> 한글명)
export const PERM_LABELS = Object.freeze({
  [PERM.NOTICE_WRITE_EDIT]: "서비스 공지사항 작성·수정",
  [PERM.OBJECT3D_CREATE]: "3D 데이터 생성",

  [PERM.PROJECT_READ]: "프로젝트 조회",
  [PERM.PROJECT_CREATE_FILE_UPLOAD]: "프로젝트 파일 업로드",
  [PERM.PROJECT_UPDATE_FILE_UPDATE]: "프로젝트 파일 수정",
  [PERM.PROJECT_DELETE_FILE_DELETE]: "프로젝트 파일 삭제",

  [PERM.REPORT_CREATE]: "보고서 생성",

  [PERM.USER_REGISTER]: "사용자 등록",
  [PERM.USER_PERMISSION_EDIT]: "사용자 권한 변경",
  [PERM.ORGANIZATION_CREATE]: "조직 생성",
  [PERM.ORGANIZATION_USER_MOVE]: "구성원 소속 조직 이동",
});
